import { useEffect, useState } from "react";
import { api, parseApiError } from "@/lib/api";
import { PageHeader } from "./AdminLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";

export default function HRMTraining() {
  const [catalog, setCatalog] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [form, setForm] = useState({ code: "", title: "", validity_days: "" });
  const [assign, setAssign] = useState({ training_id: "", employee_id: "" });

  const load = async () => {
    const [catRes, empRes] = await Promise.all([api.get("/hrm/training/catalog"), api.get("/employees")]);
    setCatalog(catRes.data); setEmployees(empRes.data);
  };
  useEffect(() => { load().catch(() => toast.error("Không tải được đào tạo")); }, []);

  const save = async () => {
    try {
      await api.post("/hrm/training/catalog", { ...form, validity_days: form.validity_days ? Number(form.validity_days) : null });
      setForm({ code: "", title: "", validity_days: "" }); await load(); toast.success("Đã tạo khóa đào tạo");
    } catch (e) { toast.error(parseApiError(e, "Lỗi").message); }
  };
  const assignTraining = async () => {
    try {
      await api.post("/hrm/training/assign", { training_id: assign.training_id, employee_ids: [assign.employee_id] });
      toast.success("Đã giao đào tạo");
    } catch (e) { toast.error(parseApiError(e, "Lỗi").message); }
  };

  return (
    <div data-testid="page-hrm-training">
      <PageHeader kicker="HRM" title="Đào tạo" breadcrumb={["HRM", "Đào tạo"]} />
      <div className="p-6 lg:p-8 grid grid-cols-1 lg:grid-cols-2 gap-4">
        <section className="space-y-3">
          <h3 className="font-semibold">Catalog đào tạo</h3>
          <Input placeholder="Mã khóa" value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value })} />
          <Input placeholder="Tên khóa" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} />
          <Input type="number" placeholder="Hiệu lực ngày" value={form.validity_days} onChange={(e) => setForm({ ...form, validity_days: e.target.value })} />
          <Textarea placeholder="Mô tả" value={form.description || ""} onChange={(e) => setForm({ ...form, description: e.target.value })} />
          <Button onClick={save} className="rounded-sm bg-emerald-800 hover:bg-emerald-900">Tạo khóa</Button>
          <div className="bg-white border border-stone-200 rounded-sm divide-y">
            {catalog.map((item) => <div key={item.id} className="p-3 text-sm"><b>{item.title}</b><div className="text-xs text-stone-500">{item.code} · {item.validity_days || "Không hết hạn"} ngày</div></div>)}
          </div>
        </section>
        <section className="space-y-3">
          <h3 className="font-semibold">Giao đào tạo</h3>
          <select className="w-full h-9 border border-stone-200 rounded-sm px-2" value={assign.training_id} onChange={(e) => setAssign({ ...assign, training_id: e.target.value })}>
            <option value="">Chọn khóa</option>
            {catalog.map((item) => <option key={item.id} value={item.id}>{item.title}</option>)}
          </select>
          <select className="w-full h-9 border border-stone-200 rounded-sm px-2" value={assign.employee_id} onChange={(e) => setAssign({ ...assign, employee_id: e.target.value })}>
            <option value="">Chọn nhân viên</option>
            {employees.map((item) => <option key={item.id} value={item.id}>{item.full_name} ({item.code})</option>)}
          </select>
          <Button onClick={assignTraining} className="rounded-sm bg-emerald-800 hover:bg-emerald-900">Giao đào tạo</Button>
        </section>
      </div>
    </div>
  );
}
